import { gql } from '@grandvisionhq/graphql';
import { contactLensLineItemFragment, prescriptionGlassLineItemFragment, solutionLineItemFragment, contactLensBundleLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, regularLineItemFragment } from '../fragments/line-item.js';

const GET_ORDER_DETAILS = gql`
  query getOrderDetails($orderNumber: ID!) {
    me {
      id
      order(orderNumber: $orderNumber) {
        billingAddress {
          additionalStreetInfo
          city
          countryCode
          email
          firstName
          lastName
          phone
          postalCode
          region
          streetName
          streetNumber
        }
        orderDate
        orderNumber
        paymentMethod
        paymentStatus
        receiptUrl
        shippingAddress {
          additionalStreetInfo
          city
          countryCode
          email
          externalId
          firstName
          lastName
          phone
          postalCode
          region
          streetName
          streetNumber
        }
        deliveryMethod
        price {
          currencyCode
          discountedAmount
          paymentMethodPrice
          shippingPrice
          subtotal
          total
        }
        shipmentStatus
        shipmentTrackingURL
        lineItems {
          ... on OrderLineItemRegular {
            ...RegularLineItemFragment
          }
          ... on OrderLineItemContactLens {
            ...ContactLensLineItemFragment
          }
          ... on OrderLineItemPrescriptionGlass {
            ...PrescriptionGlassLineItemFragment
          }
          ... on OrderLineItemSolution {
            ...SolutionLineItemFragment
          }
          ... on OrderLineItemBundle {
            ...ContactLensBundleLineItemFragment
          }
          ... on OrderLineItemNonPrescriptionBundle {
            ...NonPrescriptionBundleLineItemFragment
          }
        }
      }
    }
  }

  ${contactLensLineItemFragment}
  ${prescriptionGlassLineItemFragment}
  ${solutionLineItemFragment}
  ${contactLensBundleLineItemFragment}
  ${nonPrescriptionBundleOrderLineItemFragment}
  ${regularLineItemFragment}
`;

export { GET_ORDER_DETAILS };
//# sourceMappingURL=get-order-details.js.map
